function SvgLocationVwsPin({ stroke, strokeWidth, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={48}
      height={48}
      viewBox='0 0 48 48'
      fill='none'
      {...props}
    >
      <path
        fill='red'
        stroke='#fff'
        strokeWidth={2}
        d='M24 2.5c9.182 0 17.5 7.066 17.5 17.9 0 3.568-1.372 7.312-3.914 11.202-2.544 3.894-6.314 8.02-11.253 12.382l-.01.008a3.534 3.534 0 0 1-4.627 0l-.008-.007c-4.949-4.362-8.724-8.488-11.272-12.382C7.872 27.713 6.5 23.968 6.5 20.4 6.5 9.566 14.818 2.5 24 2.5z'
      />
      <path
        fill='#fff'
        d='M19.99 12.5A2.99 2.99 0 0 0 17 15.49h1.4c0-.878.712-1.59 1.59-1.59zm1.719 0v1.4h4.582v-1.4zm6.3 0v1.4c.879 0 1.59.712 1.59 1.59H31a2.99 2.99 0 0 0-2.99-2.99m-4.01 4a3 3 0 1 0 0 6 3 3 0 0 0 0-6m-7 .709v4.582H18.4v-4.582zm12.6 0v4.582H31v-4.582zm-12.6 6.3A2.99 2.99 0 0 0 19.99 26.5v-1.4a1.59 1.59 0 0 1-1.59-1.59zm12.6 0a1.59 1.59 0 0 1-1.589 1.59V26.5A2.99 2.99 0 0 0 31 23.51zm-7.89 1.59V26.5H23v5a1 1 0 1 0 2 0v-5h1.291v-1.4z'
      />
    </svg>
  )
}

export default SvgLocationVwsPin
